module.exports = __webpack_public_path__ + "static/media/quality2.0af43b35.webp";